var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconUserRound = function SvgIconUserRound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 11 11"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.1 10.2A5.1 5.1 0 1 0 5.1 0a5.1 5.1 0 0 0 0 10.2m1.2-6.6a1.2 1.2 0 1 1-2.4 0 1.2 1.2 0 0 1 2.4 0M5.1 5.4c1.325 0 2.4.76 2.4 1.697s-4.8.937-4.8 0S3.775 5.4 5.1 5.4",
    clipRule: "evenodd"
  })));
};
export default SvgIconUserRound;